import {Component, Inject} from "@angular/core";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {TranslateModule} from "@ngx-translate/core";
import {MatAccordion, MatExpansionPanel, MatExpansionPanelHeader} from "@angular/material/expansion";
import { KeyValuePipe, NgTemplateOutlet } from "@angular/common";
import {PageContentHeaderComponent} from "../page-content-header/page-content-header.component";

export interface BottomSheetData {
  type: string;
  header?: string;
  symptoms?: any;
  whomVisit?: string;
}

@Component({
  selector: "app-bottom-sheet",
  templateUrl: "./bottom-sheet.component.html",
  styleUrls: ["./bottom-sheet.component.css"],
  imports: [NgTemplateOutlet, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, KeyValuePipe, TranslateModule, PageContentHeaderComponent]
})
export class BottomSheetComponent {

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: BottomSheetData,
              private bottomSheetRef: MatBottomSheetRef<BottomSheetComponent>) {
  }

  closeBottomSheet() {
    this.bottomSheetRef.dismiss();
  }
}
